import {
  VISIT_STATUS_NEW,
  VISIT_STATUS_STARTED,
  VISIT_STATUS_COMPLETED,
  VisitStatus,
} from "@/schemas/contractorVisit";

export const getStatusBadgeVariant = (status: VisitStatus) => {
  switch (status) {
    case VISIT_STATUS_COMPLETED:
      return "success";
    case VISIT_STATUS_NEW:
      return "error";
    case VISIT_STATUS_STARTED:
      return "warning";
    default:
      return "default";
  }
};
